var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5124 16.8438V18.5625C15.5124 20.458 13.9703 22 12.0747 22H3.43765C1.54208 22 0 20.458 0 18.5625V3.4375C0 1.54201 1.54208 0 3.43765 0H12.0747C13.9703 0 15.5124 1.54201 15.5124 3.4375V5.15625C15.5124 5.63092 15.1277 6.01562 14.653 6.01562C14.1783 6.01562 13.7936 5.63092 13.7936 5.15625V3.4375C13.7936 2.48984 13.0225 1.71875 12.0747 1.71875H3.43765C2.48995 1.71875 1.71883 2.48984 1.71883 3.4375V18.5625C1.71883 19.5102 2.48995 20.2812 3.43765 20.2812H12.0747C13.0225 20.2812 13.7936 19.5102 13.7936 18.5625V16.8438C13.7936 16.3691 14.1783 15.9844 14.653 15.9844C15.1277 15.9844 15.5124 16.3691 15.5124 16.8438ZM21.3717 9.52379L19.4472 7.59943C19.1115 7.26373 18.5673 7.26373 18.2318 7.59943C17.8961 7.93495 17.8961 8.47911 18.2318 8.81464L19.6007 10.1836H9.28166C8.80697 10.1836 8.42224 10.5683 8.42224 11.043C8.42224 11.5176 8.80697 11.9023 9.28166 11.9023H19.6007L18.2318 13.2713C17.8961 13.6068 17.8961 14.151 18.2318 14.4865C18.3997 14.6544 18.6195 14.7383 18.8394 14.7383C19.0595 14.7383 19.2794 14.6544 19.4472 14.4865L21.3717 12.5621C22.2094 11.7244 22.2094 10.3615 21.3717 9.52379Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1a626be73013b4f09c4a15ecd945b8f9.svg";
export { ForwardRef as ReactComponent };